import Link from 'next/link';

interface BrandProps {
  className?: string;
}

export function Brand(props: BrandProps) {
  const { className } = props;

  return (
    <Link href="/" className={className}>
      <img width={112} height={33} src="/brand/nmrium-logo.svg" alt="Home" />
    </Link>
  );
}
